<script>
    import Image from '/srv/web/wyvr/html/releases/58819/gen/client/shop/component/Image.svelte?1733898724580';
    import MagnifyImage from '/srv/web/wyvr/html/releases/58819/gen/client/shop/component/MagnifyImage.svelte?1733898724580';
    import { get_attribute_value } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/attributes.js?1733898724580';
    import { get_image_path } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/get_image_path.js?1733898724580';
    import { onMount } from 'svelte';
    import { register } from 'swiper/element/bundle';
    import ImageDialog from '/srv/web/wyvr/html/releases/58819/gen/client/shop/component/ImageDialog.svelte?1733898724580';
    import { get_image_src_data } from '/srv/web/wyvr/html/releases/58819/gen/client/wyvr/image_utils.js?1733898724580';
    import { url_join } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/url.js?1733898724580';
    import { to_media_hash } from '/srv/web/wyvr/html/releases/58819/gen/client/wyvr/media.js?1733898724580';
    import { get_src } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/get_src.js?1733898724580';

    wyvr: {
        render: 'hydrate';
        loading: 'lazy';
    }

    // register swiper slider
    register();

    export let product;
    let media_cache;
    let selected_image;
    let selected_index = 0;
    let open = false;

    let images = get_images(product);
    $: {
        images = get_images(product);
        select_main_image(selected_index);
    }

    const image_main_widths = [500, 450, 400, 350, 300, 600, 500, 400, 300];
    const image_main_sizes = [1500, 1350, 1200, 1024, 768, 600, 500, 400, null]
        .map((screen_width, index) => {
            const width = image_main_widths[index];
            if (index + 1 === image_main_widths.length) {
                return width;
            }
            return `(min-width: ${screen_width}px) ${width}px`;
        })
        .join(', ');

    function get_images(product) {
        if (!product) {
            return [];
        }
        const images = Object.values(get_attribute_value(product, 'media_gallery')?.images || {})
            .map((image) => {
                image.src = get_image_path(image.file);
                return image;
            })
            .filter((x) => x);

        if (images.length === 0) {
            const src = get_src(product);
            images.push({
                src,
                label: 'Default'
            });
        }
        return images;
    }
    function select(image, index) {
        selected_image = image;
        if (index !== undefined) {
            selected_index = index;
        }
        select_main_image(selected_index);
    }
    function select_main_image(index) {
        // avoid out of range images
        if (index < 0 || index >= images.length) {
            index = 0;
        }
        selected_index = index;
        selected_image = images[index];
    }
    function open_selected_image() {
        open = true;
    }

    ;
    onMount(() => {
        media_cache = window?._media;

        select_main_image(selected_index);
    });
</script>

{#if product}
    <section class="m-product-media-gallery">
        {#if selected_image}
            <div class="selected">
                <MagnifyImage
                    src={selected_image.src}
                    width={600}
                    maxWidth={1200}
                    alt={selected_image.label}
                    sizes={image_main_sizes}
                    widths={image_main_widths}
                    on:click={open_selected_image}
                />
            </div>
        {/if}
        {#if images.length > 1}
            <div class="previews">
                {#each images as image, i}
                    <button on:click={() => select(image, i)} class:active={i == selected_index}>
                        <Image src={image.src} width={100} height={100} alt={image.label} />
                    </button>
                {/each}
            </div>
        {/if}
        <ImageDialog bind:open {images} index={selected_index} />
    </section>
{/if}


<style>
    .m-product-media-gallery :global(div.dialog) {
        max-width: 95vw;
    }
    @media (min-width: 480px) {
        .m-product-media-gallery :global(div.dialog) {
            max-width: 85vw;
        }
    }

    @media (min-width: 992px) {
        .m-product-media-gallery :global(div.dialog) {
            max-width: 65vw;
        }
    }

    section {
        --swiper-pagination-bottom: 0;
        --swiper-pagination-color: var(--color-primary);
        --swiper-pagination-bullet-inactive-color: var(--color-text);
    }

    section :global(picture) {
        margin: 0;
        padding: 0;
        display: block;
    }

    section :global(img) {
        display: block;
        margin: 0 auto;
        /*max-width: 100%;*/
    }

    .selected {
        margin-bottom: 0.25rem;
    }

    .selected :global(img) {
        max-width: 100%;
    }

    .previews {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(60px, 80px));
        grid-gap: 5px;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        justify-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        margin-top: 30px;
    }
    .previews :global(img) {
        aspect-ratio: 1 / 1;
    }

    .previews button {
        margin: 0;
        padding: 0;
        display: block;
        border: 0;
        cursor: pointer;
        background: transparent;
        border: 1px solid #dfdfdf;
        position: relative;
        width: 80px;
        height: 80px;
        webkit-transition: 0.5s ease-in-out !important;
        transition: 0.5s ease-in-out !important;
    }

    .previews button:hover {
        border-color: #303133;
    }
    .previews:hover > button {
        opacity: 0.6;
    }
    button:hover {
        opacity: 1 !important;
    }
    .previews button:before {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        transition: opacity 0.1s linear;
        opacity: 0;
        background-color: var(--color-primary);
        mix-blend-mode: multiply;
    }
</style>